"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M44.194 6.424L2 19a1.065 1.065 0 0 0-.191 1.978l9.669 4.834zM16.078 28.042l16.149 8.143a1.065 1.065 0 0 0 1.445-.511L47.455 8.091zM12.066 31v10.185a.95.95 0 0 0 1.565.725l7.147-6.021z" })
);

